module.exports = __webpack_public_path__ + "img/allow-bottom.06fc290b.svg";